import { genericActions } from "./generic.actions";
import { technicalServiceService } from "../_services/technicalService.service";
import { InvitationsMapper } from "../_mappers";
import { invitationsService } from "../_services";
import { TECHNICAL_SERVICE_ACTION_TYPES } from "../_constants/technicalService.constants";
import { LOCAL_INVITATION_STATUS } from "../_constants/invitations.constants";
import { Selectors } from "../_reducers/app.reducer";
import { appPermissions } from "../_constants/permissions.constants";

export const technicalServiceActions = {
    loadSatInvitations,
    clearSatInvitations,
    requestSat,
    disableSat,
};

// Every action takes an optional `locationUid`. Without it they work on the
// location selected in the Everou slice, as they always did; with it they work
// on that location regardless of the slice, which is how PMS (whose selected
// location lives in its own slice) reuses them. A caller passing the uid is
// expected to have checked the permission itself, since the Everou permission
// selector says nothing about that location.
function loadSatInvitations(locationUid = null) {
    return async (dispatch, getState) => {
        return await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            const isEverouSelection = !locationUid;

            if (isEverouSelection) {
                if (!appPermissions.canRequestSat(
                    Selectors.getPermissionSelectedLocation(getState())
                )) return;

                locationUid = Selectors.getSelectedLocationUid(getState());
            }

            const serverInvitations =
                await invitationsService.getInvitationsList({
                    loc_uid: locationUid,
                    sat: true,
                });

            // A slow response must not overwrite the list of the location
            // the user switched to meanwhile. With an explicit uid the store
            // cannot tell what is current, so the reducer keeps the uid the
            // list belongs to and the view ignores a list for another one.
            if (isEverouSelection &&
                Selectors.getSelectedLocationUid(getState()) !== locationUid)
                return;

            const invitations = InvitationsMapper
                .mapAllServerToLocal(serverInvitations)
                .filter(invitation => invitation.sat)
                .filter(invitation =>
                    invitation.localStatus === LOCAL_INVITATION_STATUS.REQUESTED ||
                    invitation.localStatus === LOCAL_INVITATION_STATUS.ACTIVE
                );

            dispatch(setSatInvitations(invitations, locationUid));
        }
    }
}

function requestSat(locationUid = null) {
    return async (dispatch, getState) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            await technicalServiceService.requestSatInvitation(
                locationUid ?? Selectors.getSelectedLocationUid(getState())
            );

            await dispatch(technicalServiceActions.loadSatInvitations(locationUid));
        }
    }
}

function disableSat(invitationUid, locationUid = null) {
    return async (dispatch) => {
        await dispatch(genericActions.genericAsyncAction(asyncAction));

        async function asyncAction() {
            if (!invitationUid)
                return;

            await invitationsService.deleteInvitation(invitationUid);

            await dispatch(technicalServiceActions.loadSatInvitations(locationUid));
        }
    }
}

function clearSatInvitations() {
    return setSatInvitations([], null);
}

function setSatInvitations(invitations = [], locationUid = null) {
    return {
        type: TECHNICAL_SERVICE_ACTION_TYPES.SET_SAT_INVITATIONS,
        invitations,
        locationUid,
    };
}
